import React from 'react';

import colors from '@constants/colors';

import { IIconProps, TIconType } from '../interface';

const VendorsIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-id='icon'
			data-testid='vendors'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<g clipPath='url(#clip0_24168_459949)'>
				<path
					d='M16.4 17.5C18.4711 17.5 20.15 15.8211 20.15 13.75C20.15 11.6789 18.4711 10 16.4 10C14.3289 10 12.65 11.6789 12.65 13.75C12.65 15.8211 14.3289 17.5 16.4 17.5Z'
					data-id='icon'
					fill={props?.isActive ? colors.indigo70 : 'none'}
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M11 20.875C11.4939 19.8635 12.262 19.0111 13.2167 18.4148C14.1714 17.8186 15.2744 17.5024 16.4 17.5024C17.5256 17.5024 18.6286 17.8186 19.5833 18.4148C20.538 19.0111 21.3061 19.8635 21.8 20.875'
					data-id='icon'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M3.98786 12.8615C4.04895 12.8615 4.10866 12.8432 4.15949 12.8089C4.21032 12.7747 4.25 12.726 4.27355 12.669C4.29709 12.612 4.30345 12.5492 4.29183 12.4886C4.2802 12.428 4.25111 12.3722 4.20821 12.3282C4.1991 12.319 3.30004 11.3859 2.86039 9.91749C2.60545 9.06658 2.55238 8.20028 2.7021 7.34449C2.89096 6.26816 3.40449 5.19893 4.22863 4.16652C4.27617 4.10162 4.29707 4.02067 4.28698 3.94056C4.27688 3.86045 4.23657 3.78738 4.17446 3.73661C4.11234 3.68584 4.03323 3.6613 3.95365 3.66811C3.87406 3.67492 3.80015 3.71255 3.74736 3.77315C2.85246 4.89433 2.29471 6.0651 2.08984 7.25283C1.92478 8.20974 1.98735 9.17626 2.27598 10.1257C2.76492 11.7341 3.72772 12.7276 3.76856 12.7692C3.79725 12.7985 3.83141 12.8217 3.86906 12.8376C3.9067 12.8534 3.94708 12.8616 3.98786 12.8615Z'
					data-id='icon'
					fill='#2E2E6B'
					stroke='#2E2E6B'
					strokeWidth='0.1'
				/>
				<path
					d='M6.69534 10.3918C6.7548 10.3918 6.81301 10.3745 6.86301 10.342C6.91301 10.3094 6.95268 10.263 6.97728 10.2083C7.00188 10.1535 7.01037 10.0928 7.00173 10.0333C6.99309 9.97381 6.96769 9.9181 6.92856 9.87283C5.53418 8.25819 6.86508 6.71734 6.92505 6.64961C6.98024 6.58803 7.00898 6.5068 7.00495 6.42379C7.00091 6.34078 6.96443 6.2628 6.90352 6.20699C6.84261 6.15118 6.76228 6.12212 6.68018 6.1262C6.59809 6.13028 6.52096 6.16717 6.46576 6.22876C6.44755 6.24914 6.01584 6.73615 5.7981 7.47383C5.5931 8.16797 5.54199 9.21893 6.46147 10.2841C6.49049 10.318 6.52641 10.3452 6.56677 10.3638C6.60713 10.3823 6.65099 10.3919 6.69534 10.3918Z'
					data-id='icon'
					fill='#2E2E6B'
					stroke='#2E2E6B'
					strokeWidth='0.1'
				/>
				<path
					d='M4.06253 9.51114C4.39435 10.6344 5.04991 11.3494 5.0771 11.3787C5.13326 11.4393 5.21093 11.4749 5.29303 11.4776C5.37512 11.4803 5.45492 11.4499 5.51486 11.3931C5.5748 11.3363 5.60997 11.2578 5.61264 11.1748C5.61531 11.0917 5.58526 11.0111 5.5291 10.9505C5.52312 10.944 4.93454 10.2971 4.64864 9.30848C4.2726 8.0083 4.5732 6.74389 5.54211 5.55183C5.56849 5.52012 5.58838 5.48345 5.60064 5.44391C5.6129 5.40438 5.61728 5.36279 5.61353 5.32153C5.60977 5.28028 5.59796 5.24018 5.57877 5.20358C5.55959 5.16697 5.5334 5.13458 5.50175 5.10828C5.47009 5.08198 5.43358 5.06229 5.39435 5.05035C5.35511 5.03842 5.31392 5.03448 5.27316 5.03875C5.23241 5.04303 5.1929 5.05544 5.15692 5.07526C5.12094 5.09509 5.08921 5.12194 5.06357 5.15425C3.67765 6.86226 3.75387 8.46624 4.06253 9.51114Z'
					data-id='icon'
					fill='#2E2E6B'
					stroke='#2E2E6B'
					strokeWidth='0.1'
				/>
				<path
					d='M13.2596 3.77318C14.0762 4.79634 14.6121 5.8608 14.8553 6.94176C14.8935 7.11156 14.7755 7.27403 14.6033 7.29978C14.4369 7.32467 14.2818 7.21209 14.2439 7.04814C14.0183 6.07208 13.526 5.10412 12.7776 4.16654C12.7273 4.10181 12.7041 4.01961 12.7133 3.93776C12.7224 3.8559 12.7631 3.78099 12.8265 3.72925C12.8899 3.67751 12.9709 3.6531 13.052 3.66132C13.133 3.66955 13.2076 3.70973 13.2596 3.77318Z'
					data-id='icon'
					fill='#2E2E6B'
					stroke='#2E2E6B'
					strokeWidth='0.1'
				/>
				<path
					d='M10.1081 10.3145C10.1699 10.3691 10.2507 10.3966 10.3326 10.391C10.4146 10.3854 10.491 10.3471 10.545 10.2846C11.4648 9.21927 11.4137 8.16845 11.2083 7.4743C10.9906 6.73662 10.5589 6.24962 10.5405 6.22923C10.5132 6.19877 10.4802 6.17406 10.4434 6.15649C10.4067 6.13893 10.3668 6.12886 10.3262 6.12686C10.2856 6.12487 10.245 6.13098 10.2067 6.14486C10.1684 6.15873 10.1332 6.1801 10.103 6.20773C10.0729 6.23536 10.0485 6.26872 10.0311 6.30591C10.0137 6.3431 10.0038 6.38338 10.0018 6.42445C9.99982 6.46553 10.0059 6.5066 10.0196 6.54531C10.0333 6.58403 10.0544 6.61963 10.0818 6.65009C10.0853 6.6539 10.4369 7.05055 10.6151 7.65343C10.8483 8.44345 10.6671 9.19007 10.0781 9.87278C10.0514 9.90376 10.031 9.93977 10.018 9.97875C10.005 10.0177 9.99979 10.0589 10.0026 10.0999C10.0053 10.141 10.0161 10.181 10.0342 10.2178C10.0523 10.2547 10.0774 10.2875 10.1081 10.3145Z'
					data-id='icon'
					fill='#2E2E6B'
					stroke='#2E2E6B'
					strokeWidth='0.1'
				/>
				<path
					d='M11.9426 5.15529C13.1969 6.69938 13.2541 8.15884 13.0253 9.19674C12.9871 9.36982 12.8041 9.4633 12.6366 9.40544C12.4801 9.35139 12.3948 9.1843 12.4294 9.0224C12.6855 7.82309 12.3615 6.65716 11.464 5.55286C11.4376 5.52116 11.4177 5.48448 11.4055 5.44495C11.3932 5.40542 11.3888 5.36382 11.3926 5.32257C11.3964 5.28131 11.4082 5.24122 11.4274 5.20462C11.4465 5.16801 11.4727 5.13562 11.5044 5.10932C11.536 5.08301 11.5725 5.06333 11.6118 5.05139C11.651 5.03946 11.6922 5.03551 11.733 5.03979C11.7737 5.04406 11.8132 5.05647 11.8492 5.0763C11.8852 5.09613 11.9169 5.12297 11.9426 5.15529Z'
					data-id='icon'
					fill='#2E2E6B'
					stroke='#2E2E6B'
					strokeWidth='0.1'
				/>
				<path
					d='M9.1537 8.8233C9.26978 8.69455 9.34557 8.53394 9.37152 8.36171C9.39747 8.18948 9.37243 8.01333 9.29953 7.85547C9.22664 7.6976 9.10916 7.56509 8.96191 7.47462C8.81465 7.38415 8.64421 7.33978 8.47205 7.34709C8.2999 7.3544 8.13374 7.41308 7.99451 7.51571C7.85528 7.61835 7.74921 7.76036 7.68967 7.92385C7.63013 8.08734 7.61978 8.26499 7.65993 8.43441C7.70008 8.60384 7.78892 8.75746 7.91528 8.87591L3.31968 20.5709C3.30392 20.6093 3.29587 20.6504 3.29599 20.6919C3.29611 20.7335 3.3044 20.7746 3.32037 20.8128C3.33635 20.8511 3.35969 20.8858 3.38905 20.9148C3.4184 20.9439 3.45317 20.9667 3.49135 20.9821C3.52952 20.9974 3.57033 21.0049 3.61139 21.0041C3.65246 21.0034 3.69297 20.9943 3.73056 20.9776C3.76815 20.9609 3.80207 20.9367 3.83034 20.9066C3.85861 20.8765 3.88068 20.841 3.89525 20.8021L5.48214 16.7646L11.7552 19.0377L12.1101 18.6344C12.1251 18.6726 12.1474 18.7075 12.1757 18.737C12.2041 18.7665 12.2379 18.79 12.2752 18.8063C12.3126 18.8226 12.3527 18.8313 12.3934 18.8319C12.4341 18.8325 12.4745 18.825 12.5123 18.8098C12.5501 18.7946 12.5845 18.7721 12.6137 18.7434C12.6429 18.7148 12.6662 18.6806 12.6823 18.6428C12.6984 18.6051 12.707 18.5645 12.7076 18.5234C12.7082 18.4822 12.8541 18.328 12.8391 18.2898L9.1537 8.8233ZM10.226 13.2488L7.70261 12.0843L9.42802 11.2191L10.226 13.2488ZM8.50815 9.11159C8.53825 9.11161 8.56834 9.11003 8.59829 9.10686L9.19896 10.6356L7.56889 11.4531L8.48916 9.11106C8.4954 9.1112 8.50177 9.11159 8.50815 9.11159ZM7.15058 12.5181L10.0499 13.8565L5.87457 15.7657L7.15058 12.5181ZM6.139 16.3321L10.6304 14.2785L12.2848 18.4886L6.139 16.3321Z'
					data-id='icon'
					fill='#2E2E6B'
					stroke='#2E2E6B'
					strokeWidth='0.1'
				/>
			</g>
			<defs>
				<clipPath id='clip0_24168_459949'>
					<rect
						data-id='icon'
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default VendorsIcon;
